<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="80px">
				<el-row>
					<el-col :span="5">

						<el-form-item label="开始时间">
							<el-date-picker value-format="yyyy-MM-dd" @change="list"
								v-model="searchParams.bfdate" type="date" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="结束时间">
							<el-date-picker value-format="yyyy-MM-dd" @change="list"
								v-model="searchParams.enddate" type="date" placeholder="选择日期">
							</el-date-picker>

						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label="类型" >
							<el-select v-model="searchParams.type" @change="list" placeholder="请选择">
								<el-option v-for="item in ['全部','有效期','未报名','已过期']" :key="item" :label="item"
									:value="item">
								</el-option>
							</el-select>

						</el-form-item>
					</el-col>
					<div class="search-btn">
						<el-button type="primary" icon="el-icon-search" @click="list">搜索</el-button>
						<el-button @click="clearSearchVal">清空</el-button>
					</div>
				</el-row>
			</el-form>
		</div>

		<div class="dataTable autoFlex" v-if="listData">
			<el-table class="table" :data="listData.records" stripe border height="auto"
				@selection-change="selectionChange" v-loading="listLoading">
				<el-table-column type="selection" width="55" fixed="left"></el-table-column>
				<el-table-column prop="actualName"  width="130"  label="会员名称"></el-table-column>
				<el-table-column prop="maxPaytm" label="末次报名(交费)时间"></el-table-column>
				<el-table-column prop="maxUntilTime" label="会员到期"></el-table-column>
				<el-table-column prop="countOrder" width="90" label="购课次数">
				</el-table-column>
				<el-table-column prop="loginName" label="登录帐号"></el-table-column>
				<el-table-column prop="createTime" label="注册时间"></el-table-column>
				<el-table-column prop="gender" width="55" label="性别">
					<template slot-scope="scope">
						{{ scope.row.gender == 1 ? "男" : "女" }}
					</template>
				</el-table-column>

				<el-table-column prop="phone" label="手机号码"></el-table-column>
				<el-table-column label="操作" fixed="right" width="220px">
					<template slot-scope="scope">
						<div class="dataTable-operator">
						 
							<el-button v-has-permission-code-and="'00850005'" size="mini"
								icon="el-icon-search" @click="toDetail(scope.row)">详情</el-button>

						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pageBar">
				<el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
					:page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
					:page-sizes="this.$constant.page.pageSizes"></el-pagination>
			</div>
		</div>
		<edit ref="edit"></edit>
	</div>
</template>
<script>
import edit from './edit.vue';
import api from '@/api/online/temployee/temployee.js';
export default {
	name: 'tEmployee',
	components: {
		edit
	},
	data() {
		return {
			searchParams: {},
			isShowMoreSearch: false,
			listLoading: false,
			listData: [],
			selected: [],
			page: new this.$constant.pageObj()
		};
	},
	methods: {
		//获取数据
		list() {
			this.listLoading = true;

			let params = this.$utils.merger(this.searchParams, this.page);

			if (this.searchParams.type == '全部') { 
			   delete params.type  //不传参
			}
		

			api.list(params, response => {
				this.listData = response.data;
				this.listLoading = false;
			})
		},

		//测试传输


		//去详情
		toDetail(row) {
			this.$refs.edit.open(row, '详情', true);
		},

		//批量删除
		batchRemove() {
			if (!this.selected || this.selected.length == 0) {
				this.$utils.msg.info('请选择至少一行');
				return;
			}
			let parameter = {
				ids: this.selected
			};
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove({
					ids: this.selected
				},
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//改变选择项
		selectionChange(val) {
			//清空
			this.selected = [];
			for (let item of val) {
				this.selected.push(item.id);
			}
		},
		//改变每页显示数量
		sizeChange(val) {
			this.page.size = val;
			this.list();
		},
		//改变现在的页码
		currentChange(val) {
			this.page.current = val;
			this.list();
		},
		//清空搜索框
		clearSearchVal() {
			this.searchParams = {type:"全部"};
			this.list()
		}
	},
	mounted() {
		this.list();
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
</style>
